module.exports = __webpack_public_path__ + "static/ride-story-left-7f70573615087e5ed6f9877de7539b27.png";